import BodyContentRenderer from '@components/body-content/body-content.view';

export default BodyContentRenderer;
